import {AccountModel, NewGetPropertiesWithRightOfUseAccountOutput, PermissionModel} from "~/gen/openapi/portalService";
import {GEOGRAPHY_CHECK_GLOMMEN_MJOSEN_SKOG_SA} from "~/constants/geography";

export const getIsAllowedToBecomeShareholder = (activeAccountData: AccountModel, propertiesWithRightOfUse: NewGetPropertiesWithRightOfUseAccountOutput, accounts: PermissionModel[]) => {
    const bankIDStore = useBankIDStore()
    const bankIdVerified = computed(() => {
        return !bankIDStore.requiresBankIDAuthentication
    })

    const loggedInUserHasRightOfUse = computed(() => {
        return propertiesWithRightOfUse.Properties?.some(property => {
            return property.AccountsWithRightOfUse?.some(accountWithRoU => {
                return accounts?.some(account => account.AccountId === accountWithRoU.AccountWithRightOfUse?.AccountId)
            })
        })
    })

    const loggedInUserHasPowerOfAttorney = computed(() => {
        return propertiesWithRightOfUse?.Properties?.some(property => {
            return property.PowersOfAttorney?.some(accountWithPoa => {
                return accounts?.some(account => account.AccountId === accountWithPoa.PowerOfAttorneyAccount?.AccountId)
            })
        })
    })

    const isInsideCoreGeography = computed(() => activeAccountData?.GeographyCheckNewRegistrations?.some(value => value === GEOGRAPHY_CHECK_GLOMMEN_MJOSEN_SKOG_SA))

    return !!(bankIdVerified.value && loggedInUserHasRightOfUse.value && loggedInUserHasPowerOfAttorney.value && isInsideCoreGeography.value)
}